import React, { useEffect, useRef } from "react";
import { GenerateCodeChallenge, GenerateCodeVerifier } from "../../../utils/helpers/auth";
import settings from "../../../settings";
import { routeUrls } from "../../../config/routeUrls";
import ApplicationFallback from "../../../components/applicationFallback/ApplicationFallback";

const Authorize: React.FC = () => {
    const canGo = useRef(true);
    useEffect(() => {
        if (canGo.current) {
            canGo.current = false;

            // Genero PKCE
            const codeVerifier = GenerateCodeVerifier();
            const codeChallenge = GenerateCodeChallenge(codeVerifier);
            window.sessionStorage.setItem('codeVerifier', codeVerifier);            

            // Costruisco chiamata verso Authorize endpoint
            const authorizeUrl = `${settings.idpBaseUrl}${settings.idpAuthorizeEndpoint}` +
                "?client_id=" + settings.clientId +
                "&redirect_uri=" + encodeURIComponent(window.location.origin + routeUrls.loginCallback) +
                "&response_type=code" +
                "&scope=" + encodeURIComponent("openid profile email offline_access usl_vlm usl_telematics vlm_scope documentale_scope") +
                "&code_challenge_method=S256" +
                "&code_challenge=" + codeChallenge;

                console.log("Authorize",authorizeUrl);
            window.location.href = authorizeUrl;
        }
    }, []);
    
    return (
        <ApplicationFallback />
    )
}

export default Authorize;